import { render } from "./NavBarMobile.vue?vue&type=template&id=0513271e"
import script from "./NavBarMobile.vue?vue&type=script&lang=js"
export * from "./NavBarMobile.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__